import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { EnhancedTable } from '../../../components/table'
import Tooltip from '@material-ui/core/Tooltip'
import DeleteIcon from '@material-ui/icons/Delete'

import * as actions from './actions'
import {
    permission,
    ORGANISATIONS,
    UPDATE_ORGANISATION,
    CREATE_ORGANISATIONS,
    LIST_ORGANISATIONS,
    DELETE_ORGANISATION,
} from '../../../actions/permissions'

import _ from 'lodash'

import { EditInput } from '../../../components/table'

export class OrganisationsTable extends React.Component {

    componentWillMount() {
        if (permission(this.props.user, LIST_ORGANISATIONS)) {
            this.props.getOrganisations(this.props.user._links[ORGANISATIONS].href)
        }
    }


    render() {
        const { items, updateOrganisation, createOrganisation, deleteOrganisation } = this.props
        const canAdd = _.includes(this.props.user._embedded.permissions, CREATE_ORGANISATIONS)
        const canEdit = _.includes(this.props.user._embedded.permissions, UPDATE_ORGANISATION)
        const canDelete = _.includes(this.props.user._embedded.permissions, DELETE_ORGANISATION)

  
        const columns = [
            {
                title: 'Name',
                dataIndex: '_embedded.name',
                key: 'name',
                render: (text, record) => {
                    return canEdit && record._embedded.code ?
                        <EditInput
                            onChange={value =>
                                updateOrganisation(record._links.self.href, { ...record._embedded, name: value })
                            }
                            value={text}
                            key={record._embedded.webSafeString}
                        >{text}</EditInput>
                        : text
                }
            }, {
                title: 'Description',
                dataIndex: '_embedded.description',
                key: 'description',
                render: (text, record) => {
                    return canEdit && record._embedded.code ?
                        <EditInput
                            onChange={value =>
                                updateOrganisation(record._links.self.href, { ...record._embedded, description: value })
                            }
                            value={text}
                            key={record._embedded.webSafeString}
                        >{text}</EditInput>
                        : text
                }
            },{
                title: 'Action',
                key: 'action',
                render: (text, record) => {
                    return canDelete && record._embedded.code ?
                            <Tooltip title="Delete organisation" >
                                <a aria-label="Delete organisation" onClick={e => { e.preventDefault(); deleteOrganisation(record._links.self.href) }}><DeleteIcon /></a>
                            </Tooltip> : null
                }
            }
        ]

        return (
            <React.Fragment>
                <EnhancedTable
                    columns={columns}
                    dataSource={items}
                    rowKey={record => record._links.self.href}
                    canCreate={ canAdd }
                    onCreate={ _ => createOrganisation(this.props.user._links[ORGANISATIONS].href)}
                    canDelete={ canDelete }
                    onDelete={ e => deleteOrganisation(e._links.self.href)}
                    pagination
                />

            </React.Fragment>
        )
    }
}

OrganisationsTable = connect(
    state => ({
        items: Object.values(state.organisations.items),
        user: state.user.profile,
    }),
    dispatch => (
        bindActionCreators(actions, dispatch)
    )
)(OrganisationsTable)


// WEBPACK FOOTER //
// ./src/App/Admin/Organisations/OrganisationsTable.jsx